import React, { memo } from 'react';

import { Avatar, Box, Typography } from '@mui/material';
import LabelCDS from '@sharedCR/coreDesignSystem/LabelCDS';
import { LabelSize } from '@sharedCR/coreDesignSystem/LabelCDS/LabelCDS.constants';
import { authorAvatarWithBorderStyles } from 'app/shared/styles/authorAvatar.styles';
import PropTypes from 'prop-types';

import { getCicAuthorInitials, getCicDisplayValue } from 'utils/cicReason';

import { commentTextStyles, struckOutTextStyles } from '../../../../LoanCicHistory.styles';

import { ORIGINAL_CHIP, ORIGINAL_ENTRY_ACTION } from './CicEditHistoryEntry.constants';
import { entryBodyStyles, entryHeaderStyles, entryStyles } from './CicEditHistoryEntry.styles';
import {
  getCommentChangeLabel,
  getEntryDateSuffix,
  getNewReasonSuffix,
  getOriginalDetails,
} from './CicEditHistoryEntry.utils';

const CicEditHistoryEntry = ({ entry }) => {
  const {
    isOriginal,
    authorName,
    date,
    action,
    isReasonChanged,
    previousReasonName,
    newReasonName,
  } = entry;

  return (
    <Box sx={entryStyles}>
      <Avatar sx={authorAvatarWithBorderStyles}>{getCicAuthorInitials(authorName)}</Avatar>
      <Box sx={entryBodyStyles}>
        <Box sx={entryHeaderStyles}>
          <Typography variant="regular14">
            <Typography component="span" variant="medium14">
              {getCicDisplayValue(authorName)}
            </Typography>
            {` ${isOriginal ? ORIGINAL_ENTRY_ACTION : action}`}
            <Typography color="text.secondary" component="span" variant="regular12">
              {getEntryDateSuffix(date)}
            </Typography>
          </Typography>
          {isOriginal && (
            <LabelCDS
              size={LabelSize.S}
              title={ORIGINAL_CHIP.title}
              variant={ORIGINAL_CHIP.variant}
            />
          )}
        </Box>

        {isOriginal && (
          <Typography color="text.secondary" sx={commentTextStyles} variant="regular12">
            {getOriginalDetails(entry)}
          </Typography>
        )}

        {isReasonChanged && (
          <Typography color="text.secondary" variant="regular12">
            <Typography component="span" sx={struckOutTextStyles} variant="regular12">
              {getCicDisplayValue(previousReasonName)}
            </Typography>
            {getNewReasonSuffix(newReasonName)}
          </Typography>
        )}

        {!isOriginal && (
          <Typography color="text.secondary" sx={commentTextStyles} variant="regular12">
            {getCommentChangeLabel(entry)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

CicEditHistoryEntry.propTypes = {
  entry: PropTypes.shape({
    isOriginal: PropTypes.bool.isRequired,
    authorName: PropTypes.string,
    date: PropTypes.string,
    action: PropTypes.string,
    reasonName: PropTypes.string,
    comment: PropTypes.string,
    isReasonChanged: PropTypes.bool,
    isCommentChanged: PropTypes.bool,
    previousReasonName: PropTypes.string,
    newReasonName: PropTypes.string,
    previousComment: PropTypes.string,
    newComment: PropTypes.string,
  }).isRequired,
};

export default memo(CicEditHistoryEntry);
